module.exports = __webpack_public_path__ + "static/media/BETH-ETH.2ec12e46.svg";